import './locales/i18n' // Initialize i18n
import './fonts.css'

import React from 'react'
import ReactDOM from 'react-dom/client'
import root from 'react-shadow'

import type { LangCode } from '@/services/schemas.ts'

import App from './App.tsx'
import styles from './globals.css?inline'

const rootEl = document.getElementById('root')
const defaultLang = (import.meta.env.VITE_DEFAULT_LANG as LangCode) || 'en'
const siteLang: LangCode = rootEl?.getAttribute('data-sitelanguage') as LangCode || defaultLang

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* @ts-expect-error Ignore, wrong types */}
    <root.div>
      <App siteLang={siteLang} />
      <style type="text/css">{styles}</style>
    </root.div>
  </React.StrictMode>,
)
